export function isHashFragment(url: string) {
	return url[0] === '#';
}
